module.exports = __webpack_public_path__ + "assets/img/6-1.48b21247.png";